import 'core-js';
/* eslint-disable no-bitwise */
if (!window.crypto.randomUUID)
	crypto.randomUUID = () =>
		([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
			(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
		);

if (!Object.groupBy) {
	Object.groupBy = function groupBy(items, callback) {
		return items.reduce((accumulator, item) => {
			const key = callback(item);
			if (!accumulator[key]) {
				accumulator[key] = [];
			}
			accumulator[key].push(item);
			return accumulator;
		}, {});
	};
}

if (!Array.prototype.at) {
	// eslint-disable-next-line no-extend-native
	Array.prototype.at = function at(index) {
		const idx = Math.trunc(index) || 0;
		const position = idx < 0 ? this.length + idx : idx;
		if (position < 0 || position >= this.length) return undefined;
		return this[position];
	};
}

if (!String.prototype.at) {
	// eslint-disable-next-line no-extend-native
	String.prototype.at = function at(index) {
		const idx = Math.trunc(index) || 0;
		const position = idx < 0 ? this.length + idx : idx;
		if (position < 0 || position >= this.length) return undefined;
		return this[position];
	};
}
